import React from "react";
import { HStack } from "web/react/emo/h-stack";
import { Text } from "web/react/emo/text";
import styles from "./divider.module.css";

export default function Divider({ children }: { children: React.ReactNode }): JSX.Element {
    return (
        <HStack spacing="xs" align="center">
            <div className={styles.line}></div>
            <Text textStyle="caption-2" align="center" color="secondary">
                {children}
            </Text>
            <div className={styles.line}></div>
        </HStack>
    );
}
